import React from 'react'
import './header.css'
import CTA from './CTA'
import ME from '../../assets/me.png'
import HeaderSocial from './HeaderSocials'

const Header = () => {
  return (
    <header id='home'>
      <div className="container header__container">
        <div>
          <div className='header__topics'>
            <h5> Hello I'm</h5>
            <h1>Anuradha Basnayake</h1>
            <h5 className="text-light">Software Engineer | Computer Science Graduate</h5>
          </div>
          <CTA />
          <HeaderSocial />
        </div>
        


        <div className="me">
          <img src={ME} alt="me" />
        </div>

        {/* <a href="#contact" className="scroll__down">Scroll Down</a> */}
      </div>
      
    </header>
  )
}

export default Header